import React, {useEffect} from 'react';
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import wrap from 'wraptile';
import {SetQcReportsStatuses, Status} from './QCReportsStatusesTypes';
import {HandleChangeSelectType} from '../../QCWorkflow/QCManager/QCManagerTypes';

export interface QCReportsStatusesContainerProps {
    isLoading: boolean;
    statuses: Status[];
    setQcReportsStatuses: SetQcReportsStatuses;
    value: string;
    onChange: HandleChangeSelectType;
}

interface OnEffectParams {
    setQcReportsStatuses: SetQcReportsStatuses;
    isLoading: boolean;
}

export const onEffect = wrap((params: OnEffectParams) => {
    const {
        setQcReportsStatuses,
        isLoading,
    } = params;
    
    if (isLoading) {
        setQcReportsStatuses();
    }
});

export const mapMenuItem = (status: Status) => (
    <MenuItem
        value={status.value}
        key={status.label}
    >
        {status.label}
    </MenuItem>
);

export const getMenuItems = (statuses: Status[]) => {
    return statuses.map(mapMenuItem);
};

export default function QCReportsStatusesContainer(props: QCReportsStatusesContainerProps) {
    const {
        isLoading,
        statuses,
        setQcReportsStatuses,
        value,
        onChange,
    } = props;
    const fetchStatuses = onEffect({
        setQcReportsStatuses,
        isLoading,
    });
    
    useEffect(fetchStatuses, []);
    
    if (isLoading) {
        return <CircularProgress />;
    }
    
    const statusItems = getMenuItems(statuses);
    
    return(
        <FormControl className="qc-report__status-dropdown">
            <InputLabel>Status</InputLabel>
            <Select
                labelId="qc-report__status"
                value={value}
                onChange={onChange}
            >
                {statusItems}
            </Select>
        </FormControl>
    );
}
